import { useEffect, useRef, useState, ElementRef, ImgHTMLAttributes, MouseEvent } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import format from 'date-fns/format';

import { scrollToBottom } from '../../../../../../utils/messages';
import { MessageTypes, Link, CustomCompMessage, GlobalState } from '../../../../../../store/types';
import { setBadgeCount, markAllMessagesRead } from '../../../../../../store/actions';
import { MESSAGE_SENDER } from '../../../../../../constants';

import './styles.scss';
import Message from './components/Message';

// @ts-ignore
type Props = {
  showTimeStamp: boolean,
  profileAvatar?: string;
  sendMessage: (message: string) => void;
  profileClientAvatar?: string;
}


function Messages({ profileAvatar, profileClientAvatar, showTimeStamp, sendMessage }: Props) {
  const dispatch = useDispatch();
  const { messages, typing, showChat, badgeCount } = useSelector((state: GlobalState) => ({
    messages: state.messages.messages,
    badgeCount: state.messages.badgeCount,
    typing: state.messages.isAwaitAnswer,
    showChat: state.behavior.showChat
  }));

  const messageRef = useRef<HTMLDivElement | null>(null);
  useEffect(() => {
    // @ts-ignore
    scrollToBottom(messageRef.current);
    if (showChat && badgeCount) dispatch(markAllMessagesRead());
    else dispatch(setBadgeCount(messages.filter((message) => message.unread).length));
  }, [messages, badgeCount, showChat]);

  const getComponentToRender = (message: MessageTypes | Link | CustomCompMessage) => {
    const ComponentToRender = Message;
    if (message.type === 'component') {
      //@ts-ignore
      return <ComponentToRender {...message.props} sendMessage={sendMessage} showTimeStamp={showTimeStamp} />
    }
    //@ts-ignore
    return <ComponentToRender message={message} sendMessage={sendMessage} showTimeStamp={showTimeStamp} />
  };

  // TODO: Fix this function or change to move the avatar to last message from response
  // const shouldRenderAvatar = (message: Message, index: number) => {
  //   const previousMessage = messages[index - 1];
  //   if (message.showAvatar && previousMessage.showAvatar) {
  //     dispatch(hideAvatar(index));
  //   }
  // }

  const isClient = (sender) => sender === MESSAGE_SENDER.CLIENT;
  if (!messages?.length) {
    return <div id="messages" className="rcw-messages-container">
      <div className="rcw-messages-container__empty-history">     Пожалуйста, начните диалог...</div>

    </div>
  }
  return (
    <div id="messages" className="rcw-messages-container" ref={messageRef}>
      {messages?.map((message, index) => {
        return <div className={`rcw-message ${isClient(message.sender) ? 'rcw-message-client' : ''}`}
          key={`${index}-${format(message.timestamp, 'HH:mm')}`}>
          {((profileAvatar && !isClient(message.sender)) || (profileClientAvatar && isClient(message.sender))) &&
            message.showAvatar &&
            <img
              src={isClient(message.sender) ? profileClientAvatar : profileAvatar}
              className={`rcw-avatar ${isClient(message.sender) ? 'rcw-avatar-client' : ''}`}
              alt="profile"
            />
          }
          {getComponentToRender(message)}
        </div>
      }
      )}
    </div>
  );
}

export default Messages;
